import * as types from 'live/redux/actionTypes';
import { RSAA } from 'redux-api-middleware';

export const liveLoadProfits = ({
  month,
  size,
  sort,
  year,
  type = 'profits',
}) => ({
  [RSAA]: {
    endpoint: `live/topprofit?year=${year}&month=${month}&size=${size}&sort=${sort}`,
    method: 'GET',
    types: [
      {
        type: types.LIVE_TOP_LIST_REQUEST,
        meta: { type, month, year },
      },
      {
        type: types.LIVE_TOP_LIST_RECEIVE,
        meta: { type, month, year },
      },
      {
        type: types.LIVE_TOP_LIST_ERROR,
        meta: { type, month, year },
      },
    ],
  },
});

export const liveLoadTopProfitMonth = ({
  month,
  size,
  year,
  type = 'dividends',
}) => ({
  [RSAA]: {
    endpoint: `live/topprofitmonth?year=${year}&month=${month}&size=${size}`,
    method: 'GET',
    types: [
      {
        type: types.LIVE_TOP_LIST_REQUEST,
        meta: { type, month, year },
      },
      {
        type: types.LIVE_TOP_LIST_RECEIVE,
        meta: { type, month, year },
      },
      {
        type: types.LIVE_TOP_LIST_ERROR,
        meta: { type, month, year },
      },
    ],
  },
});
